module.exports = __webpack_public_path__ + "media/images/cesta2-6c8812952dcb9f83e9b103981017d7df.png";